import './LoginPage.scss';
import React from "react";
import {FullPageCard} from "../../../components/full-page-card/FullPageCard";
import {useStores} from "../../../stores";
import {AlertTitle, CircularProgress} from "@mui/material";
import {observer} from "mobx-react-lite";
import {Auth0LoginButton} from "../../auth0/Auth0LoginButton";
import {FrontEggLoginButton} from "../../frontegg/FrontEggLoginButton";
import {environment} from "../../../env";
import {LoginPageAlert} from "./LoginPageAlert";
import Alert from "@mui/material/Alert";
import {isUnderConstructionMode} from "../../../utils/underConstructionMode.ts";
import {isInHibernateAppMode} from "../../../utils/disabledAppMode.ts";

export const LoginPage: React.FC = observer(() => {
    const {authStore} = useStores();
    const className = "content-container" + (environment.hasFrontegg && environment.hasAuth0 ? ' double' : ' single');
    return <FullPageCard
        className="login-component"
        content={
            <div className={className}>
                <div className="content-center">

                    {environment.hasFrontegg && <div><FrontEggLoginButton/></div>}
                    {environment.hasAuth0 && <div><Auth0LoginButton/></div>}
                    {(!environment.hasFrontegg && !environment.hasAuth0) && <div>
                        <Alert severity="error">
                            No authentication provider configured
                        </Alert>
                    </div>}

                    {authStore.authentication.isLoggingIn !== false && <div className="loading">
                        <CircularProgress size={20}/>
                    </div>}

                </div>
                <div className="content-hanging-bottom">
                    {isInHibernateAppMode() ?
                        <Alert severity="error" style={{flexGrow: '1'}}>
                            <AlertTitle>
                                The application is offline
                            </AlertTitle>
                            Please contact us for support: <a href="mailto:info@mithra-ai.com">info@mithra-ai.com</a>
                        </Alert>
                        : isUnderConstructionMode()
                            ? <Alert severity="error" style={{flexGrow: '1'}}>
                                <AlertTitle>
                                    We are currently under maintenance
                                </AlertTitle>
                                Some features may be unavailable.
                            </Alert>
                            : <LoginPageAlert/>

                    }
                </div>
            </div>}
    />;
});
